"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isWeekday = exports.WeekdaySchema = exports.allWeekdays = void 0;
const zod_1 = require("zod");
const type_validation_helpers_1 = require("../helpers/type_validation_helpers");
const typing_utils_1 = require("../typing_utils");
exports.allWeekdays = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
];
Object.freeze(exports.allWeekdays);
exports.WeekdaySchema = zod_1.z.union(typing_utils_1.mapArrayToLiteralTuple(exports.allWeekdays));
exports.isWeekday = type_validation_helpers_1.getVerboseTypeValidationFunction(exports.WeekdaySchema);
//# sourceMappingURL=weekdays_types.js.map